import { createContext } from "react";

export default createContext({
    previewOpen: false
});
